// extracted by mini-css-extract-plugin
export default {"button":"_1NIIxvY_hY","title":"_2CxVFfELLo","icon":"_3_gtFAg2sJ","content":"_3R1FXScgvP","expanded":"_1eBMIF4HbK"};
    if(module.hot) {
      // 1630071441567
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  